import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data}) => {
    const rows = [
        { label: 'Available Quantity', value: data.availableStorage },
    ];

    return (
        <PPMobileCardView
            title={data.materialName}
            rows={rows}
        />
    );
};

export default Mobile;
